module.exports = __webpack_public_path__ + "static/media/IMG_2349.a734a993.mp4";